import { Injectable } from '@angular/core';

const CryptoJS = require('crypto-js');

@Injectable()
export class EncodeService {

    constructor() { }

  encodeObject(value: object): { encode: string } {
    const json = JSON.stringify(value);
    const base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(json));
    return { encode: base64 };
  }

  decodeObject(value: string): any {
    const json = CryptoJS.enc.Base64.parse(value).toString(CryptoJS.enc.Utf8);
    return JSON.parse(json);
  }

}


